<template>
  <div>
    <div class="mt-4 pt-4">
      <h1 class="text-warning">Page not found</h1>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>
